import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import i18n from '@/i18n';
import { Icon } from '@/lib/enum/Icon';
import { StorageEnum } from '@/lib/enum/StorageEnum';
import { showSuccess } from '@/plugins/ToastNotifications';
import store from '@/store';
import { getLocalStorageItem } from '@/util/storageFunctions';
import { capitalise } from '@/util/stringFunctions';
import spacetime from 'spacetime';
import { computed } from 'vue';
import { Company, Employee } from '../../../api/v1';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportInformation',
  setup(__props) {

const currentCompany = computed<Company>(() => store.getters.currentCompany);
const loggedInEmployee = computed<Employee>(
  () => store.getters.loggedInEmployee,
);

const releaseVersion = () => {
  return (
    process.env.VUE_APP_RELEASE_VERSION ||
    spacetime.now().format('{year}.{iso-month}.{date-pad}.1-dev')
  );
};

const apiVersion = () => {
  return getLocalStorageItem(StorageEnum.ApiVersion);
};

const copySupportData = async () => {
  await navigator.clipboard.writeText(
    `{Company ID: ${currentCompany.value.id}, Employee ID: ${
      loggedInEmployee.value.id
    }, Version: ${releaseVersion()}, API: ${apiVersion()}}`,
  );
  showSuccess(
    i18n.tc('successMessage.copied', 1, {
      el: capitalise(i18n.tc('word.data')),
    }),
  );
};

return { __sfc: true,currentCompany, loggedInEmployee, releaseVersion, apiVersion, copySupportData, Button, Icon }
}

})